module.exports = __webpack_public_path__ + "img/8.61d3f415.svg";